import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CredentialsState } from '@app/resources/ngrx/states';

export const selectCredentialsState = createFeatureSelector<CredentialsState>('credentials');
export const selectJwt = createSelector(selectCredentialsState, (state) => state.jwt);
